import { FormProvider } from 'react-hook-form';
import { Form } from './Form';
import { useTherapySuppliersForm } from 'Hooks/useSuppliersForm';
import { useContext, useEffect } from 'react';
import { SuppliersContext } from 'Context/SuppliersContext';
import { SxProps } from '@mui/material';

interface ITherapySearchForm {
  formSx?: SxProps;
}
export const TherapySearchForm = ({ formSx }: ITherapySearchForm) => {
  const { therapySuppliersForm } = useTherapySuppliersForm();
  const { setFilters } = useContext(SuppliersContext);

  const specialty = therapySuppliersForm.watch('specialty');
  useEffect(() => {
    setFilters({ specialty: therapySuppliersForm.getValues('specialty') });
  }, [setFilters, specialty, therapySuppliersForm]);

  return (
    <FormProvider {...therapySuppliersForm}>
      <Form formSx={formSx} />
    </FormProvider>
  );
};
